module.exports = __webpack_public_path__ + "static/media/Ds3.3899f3c8.jpeg";